<div>
  <mat-form-field>
    <input
      matInput
      [formControl]="searchOptionsControl"
      [matAutocomplete]="auto"
      (focusout)="onFocusout()"
      data-testid="field-option-search"
      />
    <mat-autocomplete
      autoActiveFirstOption
      (optionSelected)="onSelectionChange($event.option.value)"
      #auto="matAutocomplete"
      [displayWith]="nameDisplayFn"
      [panelWidth]="'250px'"
      >
      <mat-optgroup [label]="'USERS.BULK_IMPORT.IMPORT_MAPPER.STANDARD_FIELDS' | translate">
        @for (option of filteredOptions$ | async; track option) {
          <mat-option [value]="option" data-testid="field-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-optgroup>
      <mat-optgroup [label]="'USERS.BULK_IMPORT.IMPORT_MAPPER.CUSTOM_FIELDS' | translate">
        @for (option of filteredCustomFieldOptions$ | async; track option) {
          <mat-option
            [value]="option"
            data-testid="field-option"
            >
            {{ option.name }}
          </mat-option>
        }
        <mat-option class="group-separator" [value]="createCustomFieldOption" data-testid="field-option">
          <em class="create-custom-field-label">
            {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.CREATE_NEW_CUSTOM_FIELD' | translate }}
          </em>
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
  </mat-form-field>
  @if (searchOptionsControl.value?.id !== doNotImportOptionId) {
    <button
      [matTooltip]="'USERS.BULK_IMPORT.IMPORT_MAPPER.DO_NOT_IMPORT' | translate"
      mat-icon-button
      (click)="setDoNotImport()"
      >
      <mat-icon class="material-icons md-18">clear</mat-icon>
    </button>
  }
</div>
